import { render } from "./App.vue?vue&type=template&id=44b4b7a1"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=44b4b7a1&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__